import { asyncScheduler, Observable } from 'rxjs';
import { share, take, tap } from 'rxjs/operators';
/**
 * Cache the first published value and replay it as long as it remains valid.
 */
export const cached = (getExpires) => observable => {
    let cachedValue;
    let cachedExpires;
    // Need to share the observable to ensure that concurrent subscriptions to
    // expired content result in just one subscription to the source. The shared
    // observable completes after caching the new value value, ensuring that a
    // new source subscription will be created the next time the shared
    // observable is used (after the cache expires again).
    const shared = observable.pipe(take(1), tap(value => {
        cachedValue = value;
        cachedExpires = getExpires(value);
    }), share());
    return new Observable(subscriber => {
        if (cachedExpires === undefined || asyncScheduler.now() >= cachedExpires.getTime()) {
            return shared.subscribe(subscriber);
        }
        else {
            subscriber.next(cachedValue);
            subscriber.complete();
            return () => { };
        }
    });
};
